import { notNull, isNullish } from "@/utils/helpers";
import { parseSupabaseStorageUrl } from "@/utils/supabaseStorageUrl";

const PRIVATE_SURVEY_ASSET_BUCKETS = [
  "survey-images",
  "survey-documents",
] as const;

export type PrivateSurveyAsset = {
  bucket: (typeof PRIVATE_SURVEY_ASSET_BUCKETS)[number];
  path: string;
};

export const parsePrivateSurveyAssetUrl = (
  assetUrl: string
): PrivateSurveyAsset | null => {
  const asset = parseSupabaseStorageUrl(assetUrl);
  if (isNullish(asset) || !isPrivateSurveyAssetBucket(asset.bucket))
    return null;
  return { bucket: asset.bucket, path: asset.path };
};

// Media should only come from Listen storage buckets, this function validates that.
export const isUploadedSurveyMediaUrl = (assetUrl: string): boolean =>
  notNull(parsePrivateSurveyAssetUrl(assetUrl));

const isPrivateSurveyAssetBucket = (
  bucket: string
): bucket is PrivateSurveyAsset["bucket"] =>
  PRIVATE_SURVEY_ASSET_BUCKETS.some(
    (allowedBucket) => allowedBucket === bucket
  );
